// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content {
  margin-top: 80px;
}

.sidenav-container {
  height: calc(100vh - 64px);
}

.mat-sidenav1 {
  padding: 10px 10px;
  background: #f5f7fa;
}

.mat-sidenav-content {
  padding: 10px 0;
  padding-top: 0;
  background: white;
}

.color-icon {
  color: #029de6;
}`, "",{"version":3,"sources":["webpack://./src/app/viewer/components/txtViewer.component.scss"],"names":[],"mappings":"AAWA;EACE,gBAAA;AAVF;;AAYA;EACE,0BAAA;AATF;;AAYA;EACE,kBAAA;EACA,mBAAA;AATF;;AAYA;EACE,eAAA;EACA,cAAA;EACA,iBAAA;AATF;;AAWA;EACE,cAAA;AARF","sourcesContent":["@use '@angular/material' as mat;\r\n@mixin adf-text-viewer-theme($theme) {\r\n  $background: map-get($theme, background);\r\n\r\n  .adf-txt-viewer {\r\n    background-color: mat.get-color-from-palette($background, background);\r\n    overflow: hidden;\r\n    overflow-y: scroll;\r\n  }\r\n}\r\n\r\n.content {\r\n  margin-top: 80px;\r\n}\r\n.sidenav-container {\r\n  height: calc(100vh - 64px);\r\n}\r\n\r\n.mat-sidenav1 {\r\n  padding: 10px 10px;\r\n  background: #f5f7fa;\r\n}\r\n\r\n.mat-sidenav-content {\r\n  padding: 10px 0;\r\n  padding-top: 0;\r\n  background: white;\r\n}\r\n.color-icon {\r\n  color: #029de6;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
